import React, { useContext, useEffect, useState } from 'react'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import analytics from '../../config/analytics'
import { EasybakeContext } from '../EasybakeProvider'
import Heading from '@react/react-spectrum/Heading'
import Wait from '@react/react-spectrum/Wait'
import Button from '@react/react-spectrum/Button'
import { Accordion, AccordionItem } from '@react/react-spectrum/Accordion'
import Well from '@react/react-spectrum/Well'
import Copy from '@react/react-spectrum/Icon/Copy'
import Key from '@react/react-spectrum/Icon/Key'
import Delete from '@react/react-spectrum/Icon/Delete'
import Code from '@react/react-spectrum/Icon/Code'
import Checkmark from '@react/react-spectrum/Icon/Checkmark'
import Ps from '../../asset/img/ps.svg'
import '../../style/console.css'
import { getDate, getSpAccessToken } from '../../lib/consoleApi'
import { copyText, downloadFile, setBodyHeight, goToUrlTarget } from '../../lib/easybake'
import Link from '../Nav/Link'
import ConsoleSteps from './ConsoleSteps'
import WizardProjectInfo from '../Nav/WizardProjectInfo'
import WizardAccessToken from '../Nav/WizardAccessToken'

export default function AccessToken (props) {
    const { referrer } = props || {}
    const { page, dispatch } = useContext(EasybakeContext)

    useEffect(() => {
        setBodyHeight('adobe-easybake-main-sub-pane')
    }, [])

    function goToNext(e) {
        dispatch({ type: 'set-page', payload: { page: 'helloworld' } })
    }

    return <div className="adobe-easybake-main-sub-pane">
        <div className="adobe-easybake-main-sub-pane-contents-signup">
            <div className="adobe-easybake-main-sub-pane-header">
                <ConsoleSteps referrer={page}/>
                <Heading variant="pageTitle" className="adobe-easybake-console-title">{__('console_credinfo_title')}</Heading>
                <hr className="adobe-easybake-hr" />
            </div>
            <div className="adobe-easybake-main-contents">
                <Accordion defaultSelectedIndex={1} multiselectable>
                <AccordionItem header="Your project information">
                    <WizardProjectInfo />
                </AccordionItem>
                <AccordionItem header="Generate access token">
                    <WizardAccessToken />
                </AccordionItem>
                </Accordion>
                <div className="adobe-easybake-flex-row-button-right-aligned">
                    <br />
                    <Button variant="primary" onClick={ e => goToNext(e) }>{__('console_credinfo_btn_next')}</Button>
                </div>
            <br />
            </div>
        </div>
    </div>
}
